<template>
  <div class="quiz-form">
    <div class="quiz-form__inner">
      <div class="quiz-range">
        <div class="quiz-range__fill" :style="`width: ${((range / max) * 100).toFixed(2)}%`" />
        <input v-model="range" type="range" :min="min" :max="max" :step="1" @input="input = range">
      </div>
      <div class="quiz-input">
        <input v-model="input" type="text" inputmode="numeric">
      </div>
      <div v-if="skip" class="quiz-skip" @click="$emit('next', 'don`t know')">
        <div>Not sure.</div>
        <div>Skip question</div>
      </div>
    </div>
    <button class="quiz-btn" type="button" @click="$emit('next', input)">
      Next
    </button>
  </div>
</template>

<script>
export default {
  emits: ['next'],
  props: {
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    unit: {
      type: String,
      default: null
    },
    skip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      range: this.min,
      input: this.unit ? `${this.min} ${this.unit}` : this.min
    }
  },
  watch: {
    input() {
      let val = typeof this.input !== 'number' ? Number(this.input.replace(/\D/g, '')) : this.input
      if (val > this.max) val = this.max
      this.range = val
      if (this.unit) val += ` ${this.unit}`
      this.input = val
    }
  }
}
</script>